import { sha256 } from "js-sha256";

/**
 * Deterministically assign a user to a bucket [0, bucketCount)
 * synchronously using SHA-256 of userId + experimentScope.
 *
 * The actual dates for the experiment need to be recorded manually for now.
 */
export function getABBucket(
  userId: string,
  experimentScope: string,
  bucketCount: number
): number {
  const input = `${userId}:${experimentScope}`;
  // SHA-256 hash as hex string
  const hashHex = sha256(input);

  // Take first 8 hex chars → 32 bits
  const first32BitsHex = hashHex.slice(0, 8);
  const value = parseInt(first32BitsHex, 16);

  return value % bucketCount;
}

/**
 * A/B bucketing is deterministic and queryable in Postgres.
 *
 * Database equivalent:
 *
    -- Get a stable bucket [0, 99] for a user + experiment
   mod(
    abs(('x' || substr(encode(digest(user_id || ':upload_modal_v2','sha256'),'hex'),1,8))::bit(32)::int),
    100
  )
 *
 * Example usage:
 *   - 50/50 split: ab_bucket < 50
 *   - 80/20 rollout: ab_bucket < 80
 *   - Named variants: bucket ranges (0–33, 34–66, 67–99)
 *
 * IMPORTANT:
 *   - `experimentKey` must match exactly between app and SQL.
 *   - Do NOT change experiment keys after launch.
 *   - Use new keys for follow-up experiments (e.g. *_v2).
 */
